"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
require("./sourcecode");
require("./wysiwyg");
$.fn.initDateTimePicker = function () {
    var $input = $(this);
    var $icon = $input.prev("[ref=icon]");
    var eventIcon = function eventIcon(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        $input.data("DateTimePicker").toggle();
    };
    $input.datetimepicker().on("dp.hide", function () {
        setTimeout(function () {
            $icon.one("click", eventIcon);
        }, 300);
    }).on("dp.show", function () {
        $icon.off();
    }).on("dp.change", function () {
        $input.trigger("blur");
    });
    $icon.one("click", eventIcon);
    return $input;
};


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/UI/index.ts
// module id = 459
// module chunks = 0